import { Show, SimpleShowLayout, TextField, DateField, NumberField, ReferenceManyField, Datagrid, Pagination, ImageField, ReferenceField } from "react-admin"
import { Divider } from "@mui/material"

const UploaderShow = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="email" />
        <NumberField source="pois_count" />
        <NumberField source="poi_media_count" />
        <DateField source="created_at" />
        <DateField source="updated_at" />
        <Divider />
        <ReferenceManyField pagination={<Pagination />} perPage={25} reference="poi-media" target="uploader_id" label="Poi media" sort={{ field: "created_at", order: "DESC" }}>
          <Datagrid rowClick="show">
            <TextField source="id" />
            <ReferenceField label="POI" source="poi_id" reference="pois">
              <TextField source="name" />
            </ReferenceField>
            <ImageField
              source="files.conversions.thumb.url"
              label={"Image"}
              sx={{
                maxWidth: "50px",
                "& img": {
                  maxWidth: "100%",
                },
              }}
            />
            <DateField source="created_at" />
          </Datagrid>
        </ReferenceManyField>
        <ReferenceManyField pagination={<Pagination />} perPage={25} reference="pois" target="uploader_id" label="Pois" sort={{ field: "created_at", order: "DESC" }}>
          <Datagrid rowClick="show">
            <TextField source="name" />
            <TextField source="publish_state" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
          </Datagrid>
        </ReferenceManyField>
      </SimpleShowLayout>
    </Show>
  )
}

export default UploaderShow
